<div class="widget" *transloco="let t; read: 'dashboard'">
  <h2>{{t('emailsWidgetTitle') | capitalize}}</h2>
  <app-list [emails]="emails" (flagUpdated)="onFlagUpdated($event)"></app-list>
  <div class="show-more" id="mailWidgetShowMore" *ngIf="moreThan5" [routerLink]="['/emails']">
    {{t('emailsWidgetViewAll', {value: totalEmails})}}
  </div>
  <app-no-results *ngIf="noResults"></app-no-results>
</div>
